<template>
  <teleport v-if="widget" to="#crentLocationMapFull">
    <gMap
      :mapConfig="mapConfig"
      :apiKey="apiKey"
      :height="dataHeight"
      :markers="stations"
      v-slot="{ google, map, bounds }"
      v-if="cookiefound && stations"
    >
      <div v-for="marker in stations" :key="marker.station">
        <gMapMarker
          v-if="marker.latitude != 0 && marker.latitude != null"
          :marker="marker"
          :google="google"
          :map="map"
          :bounds="bounds"
          @marker-click="infoWindow"
        />
      </div>
      <gMapUser :google="google" :map="map" :bounds="bounds" />
    </gMap>
    <div
      class="orm-container orm-background--grey"
      v-else
      :style="{ height: dataHeight + 'px' }"
    >
      <div class="orm-row center-xs">
        <div class="orm-col-xs-12 orm-relative">
          <div
            class="orm-login-widget text-left"
            style="left: 50%; transform: translate(-50%)"
          >
            <p v-html="i18n('modules/locationmap/noconsent')"></p>
            <button class="orm-btn orm-btn--large" @click="cookiefound = true">
              {{ i18n("modules/locationmap/showmap") || "Karte zeigen" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-if="showModal"
      :car="{}"
      :no-select="true"
      :show-category="true"
      :disable-carfilter="true"
      :sttype="sttype"
      @cancel="cancel()"
    />
  </teleport>
</template>

<script>
import { mapSettings } from "@/constants/mapSettings";
import { getDistanceFromLatLonInKm } from "@/constants/formater";

import { defineComponent, watchEffect, ref } from "vue";

import gMap from "@/components/maps/gMap.vue";
import gMapMarker from "@/components/maps/gMapMarker.vue";
import gMapUser from "@/components/maps/gMapUser.vue";
import Modal from "@/components/modals/modal-stationtimeselect.vue";

// import stationlist from "@/components/stationlist.vue";

import i18n from "@/mixins/mixins";

import store from "@/store";

export default defineComponent({
  name: "FullMap",
  components: { gMap, gMapMarker, gMapUser, Modal },
  mixins: [i18n],
  setup() {
    let widget = false;
    let dataHeight = 600;
    const myEle = document.getElementById("crentLocationMapFull");
    let headlinemode = "dark";
    let sttype = false;
    if (myEle !== null) {
      sttype = document.getElementById("crentReservation").dataset.stationtype;
      if (myEle.dataset.height) {
        dataHeight = parseInt(myEle.dataset.height);
      }
      widget = true;
      headlinemode = myEle.dataset.headline;
    } else {
      sttype = "ALL";
    }

    const stationsAll = store.getters["stations/GET_STATIONS_FILTERED"];

    const stations = stationsAll[sttype];
    const clientdata = store.getters["general/GET_CLIENT_DATA"];
    // let selectedStation = store.getters["userSession/GET_STATION"];
    let selectedStation = "";
    const userSession = store.state.userSession.LocalSession;

    const env = process.env;

    watchEffect(() => {
      selectedStation = store.getters["userSession/GET_STATION"];
    });

    const apiKey = clientdata["maps_apikey"];

    const mapConfig = {
      ...mapSettings,
      center: { lat: 52.29240999999999, lng: 8.920219999999972 },
    };
    const tabbar = [];
    for (const station in stationsAll) {
      if (station !== "ALL") tabbar.push(station);
    }
    const showModal = ref(false);

    const infoWindow = async () => {
      // await store.dispatch("userSession/SET_STATIONTYPE", type).then(() => {
      // });

      showModal.value = true;
      // console.log("Click: ", ev);
    };
    const cancel = () => {
      showModal.value = false;
      // console.log("Click: ", ev);
    };

    const cookiefound = ref(false);

    return {
      widget,
      selectedStation,
      getDistanceFromLatLonInKm,
      userSession,
      mapConfig,
      store,
      clientdata,
      apiKey,
      cookiefound,
      headlinemode,
      sttype,
      stations,
      env,
      tabbar,
      showModal,
      infoWindow,
      cancel,
      dataHeight,
    };
  },
});
</script>
